/* Alpine */
import Alpine from "alpinejs";
import Intersect from '@alpinejs/intersect';

/* 3rd Party */
import Cookies from 'js-cookie';
import fileDownload from 'js-file-download';
import Flickity from "flickity-fade";
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lightGallery from 'lightgallery';
import Masonry from 'masonry-layout';

/* 1st Party */
import app from "./app";
import dynamicForm from "./dynamicForm";
import infiniteScroll from "./infiniteScroll";
import productFilter from "./productFilter";
import productIndex from "./productIndex";

/* Alpine Plugins */
Alpine.plugin(Intersect);

/* Alpine Components */
Alpine.data('app', app);
Alpine.data('dynamicForm', dynamicForm);
Alpine.data('infiniteScroll', infiniteScroll);
Alpine.data('productFilter', productFilter);
Alpine.data('productIndex', productIndex);

/* Components defined in the source need Alpine to see these */
window.Cookies = Cookies;
window.fileDownload = fileDownload;
window.Flickity = Flickity;
window.lgThumbnail = lgThumbnail;
window.lgZoom = lgZoom;
window.lightGallery = lightGallery;
window.Masonry = Masonry;

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
